// extracted by mini-css-extract-plugin
export default {"noImage":"AwardRow_noImage__DmV91","noProfileImg":"AwardRow_noProfileImg__3KAeu","cursorPointer":"AwardRow_cursorPointer__05UTz"};